<template>
  <div
    class="custom-card"
  >
    <div class="custom-card-title">
      <v-skeleton-loader
        v-if="loading"
        type="text"
      />
      <div
        v-else
        class="text-h6"
      >
        {{ title }}
      </div>
    </div>
    <div class="custom-card-text">
      <v-skeleton-loader
        v-if="loading"
        type="text@3"
      />
      <div v-if="!loading">
        {{ employee }}
      </div>
      <div
        v-if="!loading"
        class="row"
        style="margin-top: 0"
      >
        <div class="custom-align col-3">
          {{ $t('course_report.seminar_information') }}
        </div>
        <div class="col-9">
          <div
            style="white-space: pre-line; font-size: small;"
            v-text="seminar"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    information: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    title() {
      return this.information.fc_flg === 0 ? this.$t('common.pre_course_report') : this.$t('common.post_course_report')
    },

    employee() {
      return `${this.information.name} (ID: ${this.information.customer_id})`
    },

    seminar() {
      const info = this.information
      const index = info.attend_count
      let result = ''
      if (info.attend_count !== null) {
        result += index === 0 ? this.$t('course_report.first_attend') : this.$t('course_report.reattended', {index: index})
      }
      result += `${info.seminar_name} \n${this.$t('course_report.seminar_date')}${this.seminarDateRangeDisplay(info.start_date, info.end_date)}`
      return result
    }
  },

  methods: {
    seminarDateRangeDisplay(startDate, endDate) {
      const start = new Date(startDate)
      const end = new Date(endDate)
      if (!endDate || start.toString() === end.toString()) {
        return startDate.replace(/-/g, '/')
      } else if (start.getMonth() === end.getMonth()) {
        return `${startDate.replace(/-/g, '/')} ~ ${end.getDate().toString().padStart(2, '0')}`
      } else {
        return `${startDate.replace(/-/g, '/')} ~ ${endDate.replace(/-/g, '/')}`
      }
    }
  }
}
</script>

<style scoped>
.custom-card {
  border: solid 1px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.custom-card-title {
  color: #fff!important;
  caret-color: #fff!important;
  background-color: var(--v-primary-base) !important;
  padding: 16px;
  line-height: 2rem;
  word-break: break-all;
}

.custom-align {
  align-self: center;
}

.custom-card-text {
  padding: 16px;
  color: var(--v-primary-base) !important;
  font-size: 14px;
}
</style>
